import {
  ApplicationRef,
  Component,
  EventEmitter,
  Inject, Input,
  NgZone,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';

import {DOCUMENT} from "@angular/common";
import {NgForm} from "@angular/forms";
import {environment} from "../../../environments/environment";
declare let Iugu;
declare let BaasCard;
declare let moment;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cad-cartaocredito',
  templateUrl: './cad-cartaocredito.component.html',
  styleUrls: ['./cad-cartaocredito.component.scss']
})
export class CadCartaocreditoComponent implements OnInit {
  @ViewChild('frm', { static: true})  frm: NgForm;
  @Input() parcelamento: any;
  @Input() textoBotao = 'Pagar no Cartão';
  @Input() provedorPagamento = 'iugu';
  @Input() modoPublico = false;
  @Output() onCriou = new EventEmitter();
  empresa: any;
  processando: any;
  mensagemSucesso: any;
  mensagemErro: any;
  cartao: any = {};
  esconderPagar = false;
  errosIugu
  carregandoIugu: boolean;
  tentativas = 0;
  erroCarregar: string;
  baasCard: any;
  constructor(private _renderer2: Renderer2,   private app: ApplicationRef,
              @Inject(DOCUMENT) private _document: Document, private _ngZone: NgZone) {
    this.carregandoIugu = true;
  }

  ngOnInit() {
    if(this.parcelamento){
      this.parcelamento.parcelas = []
      for(let i = 1; i <= this.parcelamento.numeroParcelas; i++){
        let valor: any = this.parcelamento.total / i ;

        valor = valor.toFixed(2).replace('.', ',')

        this.parcelamento.parcelas.push( { numeroParcelas: i, descricao: String(`${i}x de R$ ${valor} sem juros`)});
      }
    }



    if(this.ehCellcoin())
      this.incluaCellcoin();
    else
      this.incluaIugu();
  }

  ehCellcoin(): boolean {
    return String(this.provedorPagamento || '').toLowerCase() === 'cellcoin';
  }

  private incluaIugu() {
    let script = this._renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src =  'https://js.iugu.com/v2';
    this._renderer2.appendChild(this._document.body, script);
    this.ativeIugu();
  }

  private incluaCellcoin() {
    let script = this._renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://js.cel.cash/checkout-v2.min.js';
    this._renderer2.appendChild(this._document.body, script);
    this.ativeCellcoin();
  }

  private ativeCellcoin() {
    if(this.tentativas <= 15){
      if (typeof BaasCard === 'function'){
        try{
          this.baasCard = new BaasCard(environment.production);
          const retornoChave = this.baasCard._setPublicKey();
          const finalizou = () => {
            this.carregandoIugu = false;
            this.app.tick();
          };

          if(retornoChave && retornoChave.then)
            retornoChave.then(finalizou).catch(() => this.novaTentativaCarregarCellcoin());
          else
            finalizou();
        } catch (err){
          console.error(err)
          this.novaTentativaCarregarCellcoin();
        }
      } else {
        this.novaTentativaCarregarCellcoin();
      }
    } else {
      this.erroCarregar = 'Nao foi possivel carregar scripts de pagamento'
      this.esconderPagar  = true;
      this.carregandoIugu = false;
    }
  }

  private novaTentativaCarregarCellcoin(){
    this.tentativas++;
    setTimeout( () => { this.ativeCellcoin()}, 500);
  }

  private ativeIugu() {
    if(this.tentativas <= 15){
      if (typeof Iugu === 'object'){
        try{
          Iugu.setAccountID("DC9A148BEB274D64B3EB143F5F664803");
          if(window.location.host.indexOf('localhost') >= 0 )
            Iugu.setTestMode(true);
          this.carregandoIugu = false;
        } catch (err){
          console.error(err)
          this.novaTentativaCarregar();
        }
      } else {
         this.novaTentativaCarregar();
      }
    } else {
      this.erroCarregar = 'Nao foi possivel carregar scripts de pagamento'
      this.esconderPagar  = true;
      this.carregandoIugu = false;
    }
  }

  novaTentativaCarregar(){
    this.tentativas++;
    setTimeout( () => { this.ativeIugu()}, 500);
  }

  criarCartao() {
    if(!this.frm.valid) return;

    delete this.mensagemErro;
    delete  this.errosIugu;

    if(this.ehCellcoin())
      return this.criarCartaoCellcoin();

    if(!Iugu.utils.validateCreditCardNumber(this.cartao.numero)){
        this.mensagemErro = 'Número do cartão inválido';
        return
    }

    if(!this.cartao.bandeira){
      this.mensagemErro =
        'Não foi possível identificar a bandeira do cartão, bandeiras aceitas são: MasterCard, Visa, Elo, Diners e American Express.';
      return
    }

    if(!Iugu.utils.validateCVV(this.cartao.cvv, this.cartao.bandeira)){
      this.mensagemErro = 'Número de segurança inválido';
      return
    }

    let mesValidade = moment(this.cartao.validade).format('MM')
    let anoValidade = moment(this.cartao.validade).format('YYYY')

    if(!Iugu.utils.validateExpiration( mesValidade, anoValidade)){
      this.mensagemErro = 'Data de validade inválida'  ;
      return
    }

    let nomes = this.cartao.nome.split(" ");
    let primeiroNome = nomes[0].trim();
    let ultimoNome = this.cartao.nome.replace(primeiroNome, "").trim();

    if(!Iugu.utils.validateFirstName(primeiroNome)){
      this.mensagemErro = 'Nome impresso no cartão inválido' + primeiroNome;
      return
    }

    if(!Iugu.utils.validateLastName(ultimoNome)){
      this.mensagemErro = 'Informe o nome e sobrenome impresso no cartão'
      return
    }

    let creditCard = Iugu.CreditCard(this.cartao.numero, mesValidade, anoValidade,
      primeiroNome, ultimoNome, this.cartao.cvv);

    if(!creditCard.valid()){
      this.mensagemErro = 'Cartão nao é um cartão valido.'
      return
    }
    this.processando = true;
    Iugu.createPaymentToken(creditCard.toData(),  (response) => {
      this.app.tick();
      if (!response.errors) {
        this.cartao.token = response.id;
        let dados: any = { token: this.cartao.token,
                      numero: this.cartao.numero,
                      bandeira: this.cartao.bandeira,
                      validade: this.cartao.validade
        }

        if(this.cartao.parcelamento )
          dados.numeroParcelas = this.cartao.parcelamento.numeroParcelas

        this.onCriou.emit(dados);
      } else {
        this.processando = false;
        this.mensagemErro = "Erro salvando cartão";
        this.errosIugu = response.errors;
      }
    });
  }

  private criarCartaoCellcoin() {
    const numero = String(this.cartao.numero || '').replace(/\D/g, '');
    const cpf = String(this.cartao.cpf || '').replace(/\D/g, '');
    const cvv = String(this.cartao.cvv || '').replace(/\D/g, '');
    const mesValidade = moment(this.cartao.validade).format('MM');
    const anoValidade = moment(this.cartao.validade).format('YYYY');

    if(numero.length < 13){
      this.mensagemErro = 'Número do cartão inválido';
      return;
    }

    if(!this.modoPublico && cpf.length !== 11 && cpf.length !== 14){
      this.mensagemErro = 'CPF/CNPJ do titular inválido';
      return;
    }

    if(!/^\d{3,4}$/.test(cvv)){
      this.mensagemErro = 'CVV deve conter 3 ou 4 números';
      return;
    }

    if(!this.cartao.validade || mesValidade === 'Invalid date' || anoValidade === 'Invalid date'){
      this.mensagemErro = 'Data de validade inválida';
      return;
    }

    if(!this.baasCard){
      this.mensagemErro = 'Script de tokenização Cellcoin não carregado';
      return;
    }

    try {
      const card = this.baasCard.newCard({
        number: numero,
        holder: this.cartao.nome,
        expiresAt: `${anoValidade}-${mesValidade}`,
        cvv: cvv
      });

      if(card.validate)
        card.validate();

      const cryptData = card.encrypt(this.baasCard._publicKey);
      this.processando = true;

      const dados: any = {
        cryptData: cryptData,
        ultimosDigitos: numero.slice(-4),
        validade: `${mesValidade}/${anoValidade}`,
        nome: this.cartao.nome,
        bandeira: this.cartao.bandeira,
        cvv: cvv
      };

      if(!this.modoPublico) {
        dados.token = cryptData;
        dados.cpf = cpf;
      }

      if(this.cartao.parcelamento)
        dados.numeroParcelas = this.cartao.parcelamento.numeroParcelas;

      this.onCriou.emit(dados);
    } catch (erro) {
      if(!this.modoPublico) console.error(erro);
      this.processando = false;
      this.mensagemErro = erro?.message || 'Erro tokenizando cartão Cellcoin';
    }
  }

  canceleProcessando(){
    this._ngZone.run(() => {
      this.processando = false;
    });

  }

  exibaErro(mensagem: string) {
    this._ngZone.run(() => {
      this.mensagemErro = mensagem;
      this.processando = false;
    });
  }

  fecheMensagemSucesso() {
    delete this.mensagemSucesso;
  }

  fecheMensagemErro() {
    delete this.mensagemErro;
  }

  alterouNumeroCartao() {
    if(this.ehCellcoin()){
      this.cartao.numeroValido = String(this.cartao.numero || '').replace(/\D/g, '').length >= 13;
      return;
    }

    if(this.cartao.numero.toString().length > 5){
      let bandeira = Iugu.utils.getBrandByCreditCardNumber(this.cartao.numero);

      if(bandeira) this.cartao.bandeira = bandeira;
      else delete  this.cartao.bandeira;

      this.cartao.numeroValido = Iugu.utils.validateCreditCardNumber( this.cartao.numero );
    }
  }

  ativeAssinatura() {

  }


}
